export default "__VITE_ASSET__da98cc4e__"